export enum ModalColor {
  LIGHT = 'light',
  DARK = 'dark',
}
